export default __webpack_public_path__ + "static/media/person-fill.1ed022a6.svg";